<template>
    <div>
        <NavBar />
        <div class="navigation">
            <div class="menu">
                <router-link class="menu-option" to="/conseillers/crm">Gestion</router-link>
                <router-link class="menu-option" to="/conseillers/reporting">Reporting</router-link>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {

}
</script>

<style>
.navigation {
    height: 30px;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}

.menu {
    margin-right: 10%;
}

.menu-option {
    text-decoration: none;
    color: black;
    background-color: #296A9D;
    color: white;
    padding: 10px;
    margin: 10px;
    border-radius: 5px;
}

.router-link-active {
    color: rgb(255, 145, 0);
}
</style>
